<section class="auth-failed">
  <h1>Authentication failed</h1>
  <p>Your session could not be validated. Please try signing in again.</p>
  <button type="button" (click)="login()">Sign in</button>
</section>
